const menuItems = [
    {
        title: 'Състав',
        icon: 'fas fa-users',
        link: '/staff'
    },
    {
        title: 'Екипи',
        icon: 'fas fa-sitemap',
        link: '/teams'
    },
    {
        title: 'Документи',
        icon: 'fa fa-file-alt',
        link: '/documents',
        anyRole: ['SUPER_ADMIN', 'ADMIN']
    },
    {
        title: 'Професии',
        icon: 'fas fa-briefcase',
        link: '/professions',
        anyRole: ['SUPER_ADMIN', 'ADMIN']
    },
    {
        title: 'Фирми',
        icon: 'fas fa-building',
        link: '/companies'
    },
    {
        title: 'Автопарк',
        icon: 'fas fa-car-side',
        link: '/cars'
    },
    {
        title: 'Потребители',
        icon: 'fas fa-user-lock',
        link: '/users',
        anyRole: ['SUPER_ADMIN']
    },
    {
        title: 'Смяна на парола',
        icon: 'fas fa-key',
        link: '/change-password'
    }
];

export default menuItems;
